import script from "./software-list-top10.vue?vue&type=script&setup=true&lang=ts"
export * from "./software-list-top10.vue?vue&type=script&setup=true&lang=ts"

import "./software-list-top10.vue?vue&type=style&index=0&id=b6dc897a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6dc897a"]])

export default __exports__